<script lang="ts">
	import { onMount } from 'svelte';
	import {
		LIGHT_MODE_RAIL_FADE_MS,
		LIGHT_MODE_RAIL_HEIGHT_MS,
		PROMO_COLLAPSE_EASING,
	} from 'src/helpers/ui_transitions';

	export let open = false;

	let ready = false;

	onMount(() => {
		const frame = requestAnimationFrame(() => {
			ready = true;
		});
		return () => cancelAnimationFrame(frame);
	});
</script>

<div
	class="light-mode-rail"
	class:is-open={open}
	class:is-ready={ready}
	style="--light-mode-rail-fade: {LIGHT_MODE_RAIL_FADE_MS}ms; --light-mode-rail-height: {LIGHT_MODE_RAIL_HEIGHT_MS}ms; --light-mode-rail-ease: {PROMO_COLLAPSE_EASING};"
	inert={open ? undefined : true}
	aria-hidden={open ? undefined : 'true'}
>
	<div class="light-mode-rail-inner">
		<slot />
	</div>
</div>

<style>
	.light-mode-rail {
		display: grid;
		grid-template-rows: 0fr;
	}

	.light-mode-rail.is-open {
		grid-template-rows: 1fr;
		z-index: 1;
	}

	.light-mode-rail:not(.is-open) {
		pointer-events: none;
	}

	.light-mode-rail.is-ready {
		transition: grid-template-rows var(--light-mode-rail-height) var(--light-mode-rail-ease);
	}

	.light-mode-rail.is-ready:not(.is-open) {
		transition-delay: var(--light-mode-rail-fade);
	}

	.light-mode-rail-inner {
		min-height: 0;
		overflow: hidden;
		opacity: 0;
		display: flex;
		flex-direction: column;
		gap: var(--spacing-m);
	}

	.light-mode-rail.is-open .light-mode-rail-inner {
		opacity: 1;
	}

	.light-mode-rail.is-ready .light-mode-rail-inner {
		transition: opacity var(--light-mode-rail-fade) ease;
	}

	.light-mode-rail.is-ready.is-open .light-mode-rail-inner {
		transition-delay: var(--light-mode-rail-height);
	}

	.light-mode-rail.is-ready:not(.is-open) .light-mode-rail-inner {
		transition-delay: 0ms;
	}

	@media (prefers-reduced-motion: reduce) {
		.light-mode-rail.is-ready,
		.light-mode-rail.is-ready .light-mode-rail-inner {
			transition: none;
		}
	}
</style>
